import { render } from "./SiteNavBarLanding.vue?vue&type=template&id=537d2930&scoped=true"
import script from "./SiteNavBarLanding.vue?vue&type=script&lang=js"
export * from "./SiteNavBarLanding.vue?vue&type=script&lang=js"

import "./SiteNavBarLanding.vue?vue&type=style&index=0&id=537d2930&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-537d2930"]])

export default __exports__